import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";

const initConceptSlider = () => {
  const sliderEl = document.querySelector(".concept__slider");
  if (!sliderEl) return;

  const listEl = sliderEl.querySelector(".concept__items-wrapper");
  if (!listEl) return;

  const prevEl = sliderEl.parentElement?.querySelector(".concept__btn--prev");
  const nextEl = sliderEl.parentElement?.querySelector(".concept__btn--next");

  const slides = Array.from(listEl.querySelectorAll(".concept__item"));

  let swiperInstance = null;
  const breakpoint = window.matchMedia("(max-width: 992px)");

  const enableSwiperClasses = () => {
    sliderEl.classList.add("swiper");
    listEl.classList.add("swiper-wrapper");
    slides.forEach((slide) => slide.classList.add("swiper-slide"));
  };

  const disableSwiperClasses = () => {
    sliderEl.classList.remove("swiper");
    listEl.classList.remove("swiper-wrapper");
    slides.forEach((slide) => slide.classList.remove("swiper-slide"));
  };

  const enableSwiper = () => {
    enableSwiperClasses();

    swiperInstance = new Swiper(sliderEl, {
      modules: [Keyboard, Mousewheel, Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
      navigation: {
        prevEl,
        nextEl,
      },
    });
  };

  const checker = () => {
    if (breakpoint.matches) {
      if (!swiperInstance) {
        enableSwiper();
      }
    } else {
      if (swiperInstance !== null) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }

      disableSwiperClasses();
    }
  };

  try {
    breakpoint.addEventListener("change", checker);
  } catch (e) {
    breakpoint.addListener(checker);
  }

  checker();
};

export default initConceptSlider;
